import { appVersionsApi } from "api/appVersion";
import { useDataLoadingContext } from "contexts/DataLoadingContext";
import { useNotificationContext } from "contexts/NotificationContext";
import { defaultTableData, ITableData } from "models";
import { IAppVersion } from "models/appVersion";
import { useEffect, useState } from "react";

export default function useAppVersion() {
  const { showError } = useNotificationContext();
  const { reloadAppVersion } = useDataLoadingContext();
  const [data, setData] = useState<ITableData<IAppVersion>>(defaultTableData);

  useEffect(() => {
    fetchAppVersion();
  }, [reloadAppVersion]); // eslint-disable-line

  const fetchAppVersion = async () => {
    setData((prev) => ({ ...prev, loading: true }));

    const { data, error } = await appVersionsApi();
    if (data) {
      data.data = data.data.map((value) => ({
        ...value,
        key: value.id,
      }));
      setData((prev) => ({ ...prev, ...data, loading: false }));
    } else {
      showError(error!.message);
      setData((prev) => ({ ...prev, loading: false }));
    }
  };

  return {
    data,
  };
}
